/**
 * Created by hejikun on 2017/10/25 0025.
 */

const requireComponent = require.context('.', true, /\.vue$/)

export default {
  install: function (_Vue) {
    requireComponent.keys().forEach((fileName) => {
      const componentConfig = requireComponent(fileName)

      const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')

      _Vue.component(componentName, componentConfig.default || componentConfig)
    })
  }
}
